/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * Checks if `value` is a valid Date object
 * @param value
 *
 * Example:
 * isValidDate(new Date()) // true
 * isValidDate(new Date('Thu Jun 09 2022 20:07:46 GMT-0400 (Eastern Daylight Time)')) // true
 * isValidDate(new Date('some invalid string')) // false
 * isValidDate() // false
 * isValidDate(null) // false
 * isValidDate(undefined) // false
 */
export function isValidDate(value: unknown): value is Date {
  return !!value && !isNaN(value as number) && value instanceof Date;
}

/**
 * Creates a typeguard for the given enum, `e`
 *
 * Examples
 * ```
 * const isOrderStatus = isSomeEnum(OrderStatus);
 * const isValueAnOrderStatus = isOrderStatus('NEW');
 *
 * @param e a Typescript enum
 * @returns a typeguard function
 * ```
 */
export const isSomeEnum = <T extends { [s: string]: unknown }>(e: T) => {
  return (token: unknown): token is T[keyof T] => {
    return Object.values(e).includes(token as T[keyof T]);
  };
};
